import client from './config';
import { RequestMessagePayload } from '../interfaces/professional/Professional';

export const sendMessage = (payload: RequestMessagePayload) => {
  return client.post('/professionals/message', payload).then(response => {
    return response.data;
  });
};
